import { BankType } from '@/common/queries/selections/Banks/banks.type';
import { fetchApi } from '@/config/axiosSetting';

export const getBanksFunction = (): Promise<BankType[]> => {
  return fetchApi.get('/selection_item/bank/wop_list/');
};
